module.exports = "/_next/static/images/MLA-screenshot-bdb15897ccef1c1b4eb044069b163896.png";